import Supplier from './supplier.vue';

export default Supplier;
